import { Link, Outlet } from "react-router-dom"
import { rootPath } from "~/common/paths"
import { LoggedOutFooter } from "~/footers/logged-out-footer"
import logoIcon from "~/images/logo-icon"

/**
 * doesn't incldue navigation etc, intended mostly for pages where the user is not logged in
 */
export const MinimalCenteredLayout = () => {
  return (
    <div className="flex min-h-screen flex-col py-8">
      <div className="flex justify-center">
        <Link className="flex items-center" to={rootPath({})}>
          <img src={logoIcon.src} height={32} width={32} alt="Logo" />
          <span className="pl-2 text-xl font-bold">Tasti</span>
        </Link>
      </div>

      <main className="flex flex-1 flex-col overflow-y-auto p-4">
        <div className="mx-auto flex w-full max-w-4xl flex-1 flex-col px-4">
          <Outlet />
        </div>
      </main>

      <LoggedOutFooter className="mx-auto px-4" />
    </div>
  )
}
